import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

/**
 * Default modal options used across the application
 */
export const DEFAULT_MODAL_OPTIONS: NgbModalOptions = {
  backdrop: 'static',
  backdropClass: 'customBackdrop'
};

/**
 * Common error messages
 */
export const ERROR_MESSAGES = {
  INTERNAL_SERVER_ERROR: 'A technical error has occurred. Please contact us on:+27 860061058, for assistance with completing your registration.',
  SESSION_TIMEOUT: 'Your session has timed-out. Please try to register again.',
  CALLBACK_ERROR: 'Error: Please try after some time',
  CALLBACK_SUCCESS: 'Our coach will contact you shortly'
};

/**
 * Scrolls the window to the top smoothly
 */
export function scrollToTop(): void {
  globalThis.scroll({ top: 0, left: 0, behavior: 'smooth' });
}

/**
 * Message link template used in registration components
 */
export const MESSAGE_LINK_TEMPLATE = `<a id='messagelink' href='routeValue' class="anchorlogin" onclick='return false;'>linkText</a>`;
